module.exports = __webpack_public_path__ + "static/img/ps_new.fb343af9.png";